import apiClient from "./client";
import type { SiteMutationResponse, UpdateSitePayload } from "../types/site";
import type { IdParam } from "../types/common";

export const updateSite = async (
  siteId: IdParam,
  data: UpdateSitePayload
): Promise<SiteMutationResponse> => {
  const { data: response } = await apiClient.put<SiteMutationResponse>(
    `/site/${siteId}`,
    data
  );
  return response;
};
